export const firebaseConfig ={
    apiKey: "AIzaSyBymfZ9yBtTBXRSLGBdczWNEGltIewo4lo",
    authDomain: "servicetracking-1091.firebaseapp.com",
    databaseURL: "https://servicetracking-1091.firebaseio.com",
    projectId: "servicetracking-1091",
    storageBucket: "servicetracking-1091.appspot.com",
    messagingSenderId: "270197947708"
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/components/Config/firebase.config.ts